
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ReservationItemModule } from '@/store/modules/reservationItem';

@Component({
  name: 'RefundRulesForm',
  components: {
  },
})
export default class extends Vue {
  get cancelPolicy() {
    return ReservationItemModule.form.cancelPolicy;
  }

  private deleteRules(date: any, type: string) {
    if (type === 'consumer') {
      const index = this.cancelPolicy.clientCancelInfos.findIndex((rule: any) => rule === date);
      this.cancelPolicy.clientCancelInfos.splice(index, 1);
    } else if (type === 'manager') {
      const index = this.cancelPolicy.managerCancelInfos.findIndex((rule: any) => rule === date);
      this.cancelPolicy.managerCancelInfos.splice(index, 1);
    }
  }

  private addRefundRule(type: string) {
    const defaultRefund: any = {
      refundTermDay: 5,
      refundTermTime: '00:00',
      description: null,
      percentage: 5,
    };
    if (type === 'consumer') this.cancelPolicy.clientCancelInfos.push(defaultRefund);
    else if (type === 'manager') this.cancelPolicy.managerCancelInfos.push(defaultRefund);
  }
}
